import ListItem from "../ListItem/ListItem";
import styles from "./List.module.css";

const List = ({ items }) => (
  <ul className={styles.list}>
    {items.map((item, index) => (
      <ListItem key={index}>{item}</ListItem>
    ))}
  </ul>
);

export default List;
